module.exports = {
      id: "99f5d5c7678dbab6844e9dc3764960dasewerage-public.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#99f5d5c7678dbab6844e9dc3764960dasewerage-public.svg",
      toString: function () {
        return this.url;
      }
    }